import { render, staticRenderFns } from "./InactivityScreen.vue?vue&type=template&id=4a57b63e&scoped=true&"
import script from "./InactivityScreen.vue?vue&type=script&scoped=true&lang=js&"
export * from "./InactivityScreen.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./InactivityScreen.vue?vue&type=style&index=0&id=4a57b63e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a57b63e",
  null
  
)

export default component.exports